
import { defineComponent } from "vue";
import { contentsService, StaticContent } from "@/services/contents.service";
import { titleFilter } from "@/common/title.filter";

export default defineComponent({
  name: "Hero",
  data() {
    return {
      page: undefined as StaticContent | undefined,
    };
  },
  mounted() {
    contentsService.findBySlug("page-home-hero").then((page) => {
      this.page = page as StaticContent;
    });
  },
  methods: {
    titlePipe(title: string) {
      return titleFilter(title);
    },
  },
});
